import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { QualificationRequirement } from './types/QualificationRequirement';

export default (makeCall: MakeCall) => (listingUuid: string) =>
  makeCall<QualificationRequirement>(
    'GET',
    `/api/v2/qualification/requirements/by-listing/${listingUuid}`,
  );
